import GitHubActions from './GitHubActions'

export default GitHubActions
